import { render, staticRenderFns } from "./SaharaDesert.vue?vue&type=template&id=92b44330&"
import script from "./SaharaDesert.vue?vue&type=script&lang=js&"
export * from "./SaharaDesert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports